export default __webpack_public_path__ + "static/media/fonts/alegreyasans-bold-webfont.8e3d6023.woff";